import React from 'react';
import { ArrowIcon, Icon, Query, QueryContainer, Text } from './SearchItem.styles';
import RecentSvg from './assets/Recent.svg';
import RightArrowSvg from './assets/RightArrow.svg';
import SearchSvg from './assets/Search.svg';
export let SearchItemType = /*#__PURE__*/function (SearchItemType) {
  SearchItemType["SEARCH"] = "search";
  SearchItemType["RECENT"] = "recent";
  return SearchItemType;
}({});
export function SearchItem(_ref) {
  let {
    type,
    text,
    onClick
  } = _ref;
  const icon = type === SearchItemType.SEARCH ? /*#__PURE__*/React.createElement(Icon, {
    src: SearchSvg,
    alt: type
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: RecentSvg,
    alt: type
  });
  return /*#__PURE__*/React.createElement(Query, {
    role: "button",
    type: "button",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(QueryContainer, null, icon, /*#__PURE__*/React.createElement(Text, null, text)), /*#__PURE__*/React.createElement(ArrowIcon, {
    src: RightArrowSvg,
    alt: "select"
  }));
}